import React from "react";

const HeaderPadding: React.FC = () => {
  return <div style={{ padding: "28px" }} />;
};

export default HeaderPadding;
